import Selector from 'simple-selector';
import each from '../functions/each';
document.addEventListener('DOMContentLoaded', function () {
  // selectors
  each('.js-nav-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'navSelector',
      search: false
    });
  });
  each('.js-cta-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'ctaSelector',
      search: select.children.length >= 10
    });
    select.SS.options[0].remove();
    select.addEventListener('change', function () {
      if (select.selectedOptions[0].value.includes(window.location.origin)) window.location = select.selectedOptions[0].value;
    });
  });
  each('.js-location-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'locationSelector',
      search: select.children.length >= 10
    });
  });
  each('.js-tag-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'tagSelector',
      search: false
    });
  });
  each('.js-filter-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'filterSelector',
      search: false
    });
  });
  each('.js-holder-selector', function (select) {
    select.SS = new Selector(select, {
      "class": 'holderSelector',
      search: false
    });
  });
  each('.js-form select', function (select) {
    select.SS = new Selector(select, {
      "class": 'formSelector',
      search: false,
      placeholder: select.firstElementChild.text
    });
    select.SS.options[0].remove();
  });
  each('select', function (select) {
    if (select.SS) {
      select.addEventListener('focus', function (e) {
        select.SS.select.classList.add('focus');
      });
      select.addEventListener('blur', function (e) {
        select.SS.select.classList.remove('focus');
      });
    }
  });
});